import { cn } from "@utils"

const FormGroup = ({ children, className }) => {
  return (
    <div className={cn(
      "relative",
      className
    )}>
      {children}
    </div>
  );
};

export default FormGroup;

